/**
 * בורר מהירות השמעה להקלטות (אפיון 5.7 — עד ×3). כפתור אחד שמדלג בין
 * המהירויות במחזור, כדי לא לגזול רוחב מפס ההתקדמות בסרגל הנגן.
 */

/** המהירויות הזמינות. 1 הוא ברירת המחדל, והתקרה היא ×3 לפי האפיון. */
export const PLAYBACK_RATES = [1, 1.25, 1.5, 2, 2.5, 3] as const;

export type PlaybackRate = (typeof PLAYBACK_RATES)[number];

/** המהירות הבאה במחזור — אחרי ×3 חוזרים ל-×1. */
export function nextPlaybackRate(rate: number): PlaybackRate {
  const i = PLAYBACK_RATES.indexOf(rate as PlaybackRate);
  return PLAYBACK_RATES[(i + 1) % PLAYBACK_RATES.length];
}

/** תווית קצרה למהירות: ×1, ×1.5, ×3. */
export function formatRate(rate: number): string {
  return `×${rate}`;
}

export interface PlaybackRateControlProps {
  rate: number;
  onChange: (rate: PlaybackRate) => void;
  disabled?: boolean;
}

export function PlaybackRateControl({ rate, onChange, disabled }: PlaybackRateControlProps) {
  return (
    <button
      type="button"
      className="btn ghost"
      onClick={() => onChange(nextPlaybackRate(rate))}
      disabled={disabled}
      aria-label={`מהירות השמעה ${formatRate(rate)}`}
      title="מהירות השמעה — לחיצה מחליפה"
      style={{
        height: 30, minWidth: 46, padding: '0 8px', flexShrink: 0,
        fontFamily: 'var(--font-mono)', fontSize: 'var(--t-xs)',
        fontWeight: rate === 1 ? 400 : 600,
        color: rate === 1 ? 'var(--muted)' : 'var(--accent-ink)',
      }}
    >
      {formatRate(rate)}
    </button>
  );
}
